import { LoginOutput } from '@allocab/allocab-commons-shared-types';
import { useEffect, useMemo } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';

import { LocaleSwitch } from '../components/locale-switch/LocaleSwitch';
import { Spinner } from '../components/Spinner';
import { ThemeSwitch } from '../components/ThemeSwitch';
import { queryClient } from '../services/datastore/react-query';
import { ToastManager } from '../services/toast/utils';
import { t } from '../services/translation/translation';
import { clearTokens, updateTokens } from '../utils/auth';

export const TakeOverRoute = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const session = useMemo<LoginOutput | null>(() => {
    const s = searchParams.get('s');

    if (!s) return null;

    try {
      const parsedSession = JSON.parse(s);

      if (
        typeof parsedSession === 'object' &&
        'accessToken' in parsedSession &&
        'refreshToken' in parsedSession &&
        'issued' in parsedSession &&
        'expires' in parsedSession
      ) {
        return {
          accessToken: parsedSession.accessToken,
          refreshToken: parsedSession.refreshToken,
          issued: parsedSession.issued,
          expires: parsedSession.expires,
        };
      }
    } catch (e) {
      console.error(e);
    }

    return null;
  }, [searchParams]);

  useEffect(() => {
    if (session) {
      clearTokens(queryClient);
      updateTokens(queryClient, session);
      navigate('/');
      ToastManager.show({ severity: 'success', message: t('take-over-route.success') });
    }
  }, [navigate, session]);

  useEffect(() => {
    if (!session) {
      ToastManager.show({ severity: 'error', message: t('take-over-route.error') });
    }
  }, [session]);

  if (!session) {
    return <Navigate to="/" />;
  }

  return (
    <div className="h-screen flex items-center justify-center relative">
      <Spinner />
      <div className="absolute top-4 right-4 flex flex-row items-center gap-2">
        <ThemeSwitch />
        <LocaleSwitch />
      </div>
    </div>
  );
};
